<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">佣金明细</div>
          <div class="money">
            ￥<span class="num">{{ where.param.commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="listn" v-for="(val, indexn) in info" :key="indexn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.history }}</div>
                <div>{{ fromatDate(val.created) }}</div>
              </div>
              <div class="num">+{{ val.money }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getCommissionInfo } from "../../../api/user";
import Loading from "@components/Loading";
import dayjs from "dayjs";
export default {
  name: "CommissionDetails",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      info: [],
      commission: 0,
      where: {
        pageNo: 1,
        param: {},
        pageSize: 3,
      },
      types: 1,
      loaded: false,
      loading: false,
    };
  },
  mounted: function () {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    fromatDate(time) {
      var times = time * 1000;
      return dayjs(times).format("YYYY-MM-DD");
    },
    getIndex: function () {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getCommissionInfo(that.where, that.types).then(
        (res) => {
          that.loading = false;
          that.loaded = res.result.records.length < that.where.pageSize;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.pageNo = that.where.pageNo + 1;
          that.info.push.apply(that.info, res.result.records);
          that.where.param = res.result.param;
          console.info(this.info);
        },
        (error) => {
          that.$dialog.message(error.msg);
        }
      );
    },
  },
};
</script>
